export default {
    inserted: (el) -> 
        children = el.querySelectorAll '[data-timeline]'

        sorted = [].slice.call(children).sort (a, b) => 
            a.dataset.timeline > b.dataset.timeline ? 1 : 0
        
        delay = 400
        i = 0

        sorted.forEach (element) =>
            i++
            element.style.transitionDelay = i * 400 + 'ms'  
}
